import { MenuItem } from "@mui/material";
import WushTextField from "./WushTextField";

export default function WushYesNoField(props) {
  return (
    <WushTextField {...props} select >
      <MenuItem value={true}>
        Yes
      </MenuItem>
      <MenuItem value={false}>
        No
      </MenuItem>
    </WushTextField>
  );
}